import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=8a9801de&scoped=true&"
import script from "./TermsCard.vue?vue&type=script&lang=ts&"
export * from "./TermsCard.vue?vue&type=script&lang=ts&"
import style0 from "./TermsCard.vue?vue&type=style&index=0&id=8a9801de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9801de",
  null
  
)

export default component.exports